import { Injectable } from '@angular/core';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import {
  ProNumberReengineeringApiService,
  CreateProAssignmentRequestResp,
  ListProAssignmentRequestsResp,
  GetProMetricsResp,
  GetProMetricsPath,
  UpdateProAssignmentRequestRqst,
  UpdateProAssignmentRequestPath,
  UpdateProAssignmentRequestResp,
  UpdateProAssignmentRequestDetailRqst,
  UpdateProAssignmentRequestDetailPath,
  UpdateProAssignmentRequestDetailResp,
  GetProAssignmentRequestResp,
  GetProAssignmentRequestPath,
  CreateProPrintLabelOrderResp,
  CreateProAssignmentRequestNoteResp,
  CreateProAssignmentRequestNoteRqst,
} from '@xpo-ltl/sdk-pronumberreengineering';
import { catchError, map } from 'rxjs/operators';
import { ProPadTypeCd, ProRequestStatusCd } from '@xpo-ltl/sdk-common';
import { MetricType } from '../../shared/enums/metric-type.enum';

@Injectable({ providedIn: 'root' })
export class ProInventoryService {
  constructor(private proNumberReengineeringApiService: ProNumberReengineeringApiService) {}

  quantityDetails: BehaviorSubject<any> = new BehaviorSubject(null);
  createProLabelRequest(request: any): Observable<CreateProAssignmentRequestResp> {
    return this.proNumberReengineeringApiService.createProAssignmentRequest(request).pipe(
      map((result: CreateProAssignmentRequestResp) => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  getMetric(
    proLabelFormatTypeCd: string,
    sicCd: string,
    proPadTypeCd: ProPadTypeCd,
    metricType: MetricType,
    statusCd?: ProRequestStatusCd,
    timeRangeSince?: any,
    timeRangeUntil?: any,
    assignedToCustomerCareManager?: string,
    madCd?: string,
    requestByEmployeeId?: string
  ): Observable<GetProMetricsResp> {
    const pathParams: GetProMetricsPath = {
      proLabelFormatTypeCd: proLabelFormatTypeCd,
      metricsTypeCd: metricType,
    };
    const queryParams: any = {
      sicCd: sicCd,
      proPadTypeCd: proPadTypeCd,
      statusCd: statusCd,
      timeRangeSince: timeRangeSince,
      timeRangeUntil: timeRangeUntil,
      assignedToCustomerCareManager: assignedToCustomerCareManager,
      requestByEmployeeId: requestByEmployeeId,
      madCd: madCd,
    };
    return this.proNumberReengineeringApiService.getProMetrics(pathParams as any, queryParams).pipe(
      map((result: GetProMetricsResp) => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  getProAssignmentRequests(
    sicCd,
    statusCd,
    timeRangeSince,
    timeRangeUntil,
    labelFormat,
    madCd?,
    assignedToCustomerCareManager?
  ): Observable<ListProAssignmentRequestsResp> {
    const queryParams: any = {
      sicCd: sicCd,
      statusCd: statusCd,
      timeRangeSince: timeRangeSince,
      timeRangeUntil: timeRangeUntil,
      proLabelFormatTypeCd: labelFormat,
      madCd: madCd,
      assignedToCustomerCareManager: assignedToCustomerCareManager,
    };
    return this.proNumberReengineeringApiService.listProAssignmentRequests(queryParams).pipe(
      map((result: ListProAssignmentRequestsResp) => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  getProAssignmentRequest(proAssignmentRequestId): Observable<GetProAssignmentRequestResp> {
    const pathParams: GetProAssignmentRequestPath = {
      proAssignmentRequestId: proAssignmentRequestId,
    };
    return this.proNumberReengineeringApiService.getProAssignmentRequest(pathParams).pipe(
      map((result: GetProAssignmentRequestResp) => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  updateProAssignmentRequest(assignmentRequest, proAssignmentRequestId): Observable<UpdateProAssignmentRequestResp> {
    const pathParams: UpdateProAssignmentRequestPath = {
      proAssignmentRequestId: proAssignmentRequestId,
    };
    const request: UpdateProAssignmentRequestRqst = {
      assignmentRequest: assignmentRequest,
    };
    return this.proNumberReengineeringApiService.updateProAssignmentRequest(request, pathParams).pipe(
      map((result: UpdateProAssignmentRequestResp) => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  updateProAssignmentRequestDetail(
    assignmentRequestDetail,
    proAssignmentRequestId,
    proAssignRequestDetailSequenceNbr,
    assignmentRequestDetailNote
  ): Observable<UpdateProAssignmentRequestDetailResp> {
    const pathParams: UpdateProAssignmentRequestDetailPath = {
      proAssignmentRequestId: proAssignmentRequestId,
      proAssignRequestDetailSequenceNbr: proAssignRequestDetailSequenceNbr,
    };
    const request: UpdateProAssignmentRequestDetailRqst = {
      assignmentRequestDetail: assignmentRequestDetail,
      // assignmentRequestDetailNote: assignmentRequestDetailNote,
    };
    return this.proNumberReengineeringApiService.updateProAssignmentRequestDetail(request, pathParams).pipe(
      map((result: UpdateProAssignmentRequestDetailResp) => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  createPrintLabelOrder(order): Observable<CreateProPrintLabelOrderResp> {
    return this.proNumberReengineeringApiService.createProPrintLabelOrder(order).pipe(
      map((result: CreateProPrintLabelOrderResp) => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  createProAssignmentRequestNote(assignmentRequestNote): Observable<CreateProAssignmentRequestNoteResp> {
    const request: CreateProAssignmentRequestNoteRqst = {
      assignmentRequestNote: assignmentRequestNote,
    };
    return this.proNumberReengineeringApiService.createProAssignmentRequestNote(request).pipe(
      map((result: CreateProAssignmentRequestNoteResp) => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  handleError(err: any) {
    return throwError(err || 'backend serve error');
  }
}
